import { Heading, useColorModeValue, VStack } from "@chakra-ui/react";
import { useTranslation } from "react-i18next";
import { RiMailOpenLine } from "react-icons/ri";
import { SidebarButton } from "../layout/SidebarButton";

export function ContactUs() {
    const { t } = useTranslation();
    return (
        <VStack alignItems={"stretch"} spacing={3} color={useColorModeValue("gray.400", "gray.600")}>
            <Heading mt={4} fontSize="sm" fontWeight="normal">
                {t("about.heading5")}
            </Heading>
            <SidebarButton
                pageName="mailto:kafe@fi.muni.cz"
                iconOutline={RiMailOpenLine}
                text={t("about.paragraph6")}
                small
            />
        </VStack>
    );
}
